<template>
  <div>
    <b-row>
      <b-col>
        <div class="d-flex flex-column">
          <p
            v-if="variant !== 'danger'"
            class="text-primary"
          >
            Uploading... {{ `${_value}%` }}
          </p>
          <p
            v-else
            class="text-danger"
          >
            Uploading failed!
          </p>
        </div>
        <div>

          <b-progress
            key="1"
            :value="_value"
            max="100"
            class="progress-bar-primary"
            :variant="variant"
            animated
          />
        </div>
        <p
          v-if="variant === 'danger'"
          class="text-sm text-primary text-secondary"
        >
          {{ message }}
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    variant: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {

    }
  },
  computed: {
    _value: {
      get() { return this.value },
    },
  },
  methods: {
  },
}
</script>
